import "./ResourcePage.css"
import { resourceLinks } from "./resourceLinks.js"
import TextBubble from "../../TextBubble/TextBubble.jsx";
import ExternalLink from "../../ExternalLink/ExternalLink.jsx";

export default function ResourcePage() {

    function renderResources(resources) {
        const renderedLinks = [];
        let index = 0;
        for (const data of resources) {
            renderedLinks.push(
                <div className="resource-page-dropdown-button-pair" key={index}>
                    <ExternalLink buttonType="wide" href={data.href}>{data.name}</ExternalLink>
                    <p>{data.desc}</p>
                </div>
            )
            index++;
        }
        return renderedLinks;
    }

    function renderDropdown() {
        const sectionList = [];
        let index = 0;
        for (const section of resourceLinks) {
            sectionList.push(
                <TextBubble doLoadExpanded={false} title={section.title} key={index}>
                    <div className="resource-page-dropdown-wrapper">
                        {renderResources(section.resources)}
                    </div>
                </TextBubble>
            );
            index++;
        }
        return sectionList;
    }

    return(
        <>
            <h1>Resources</h1>
            <div className="resource-page">
                {renderDropdown()}
            </div>
        </>
    );
}